import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const QueryLibrary = () => {
  const getQueryLibraryPrompts = params =>
    AuthAxios.get(`${DataApiUrl}/admin/query-library`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const createQueryLibraryPrompt = ({ title, prompt }) =>
    AuthAxios.post(`${DataApiUrl}/admin/query-library`, { title, prompt })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const editQueryLibraryPrompt = ({ id, title, prompt }) =>
    AuthAxios.patch(`${DataApiUrl}/admin/query-library/${id}`, { title, prompt })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const deleteQueryLibraryPrompt = ({ id }) =>
    AuthAxios.delete(`${DataApiUrl}/admin/query-library/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const executeQueryLibraryPrompt = ({ prompt, ...params }) =>
    AuthAxios.post(`${DataApiUrl}/admin/query-library/execute`, { prompt, ...params })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const exportQueryResults = ({ prompt }) =>
    AuthAxios.post(`${DataApiUrl}/admin/query-library/export`, { prompt })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getQueryLibraryPrompts,
    createQueryLibraryPrompt,
    editQueryLibraryPrompt,
    deleteQueryLibraryPrompt,
    executeQueryLibraryPrompt,
    exportQueryResults,
  };
};

export default QueryLibrary;
